import { render, staticRenderFns } from "./ModificaMembro.vue?vue&type=template&id=66e41f6b&scoped=true&"
import script from "./ModificaMembro.vue?vue&type=script&lang=js&"
export * from "./ModificaMembro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e41f6b",
  null
  
)

export default component.exports